var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',{attrs:{"title":_vm.title,"is-loading":_vm.isLoading,"is-show-logout-header":true}},[_c('mypage-component',{on:{"setTitle":_vm.setTitle,"startLoading":_vm.startLoading,"endLoading":_vm.endLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }